var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25C12.25 0.25 15.75 3.75 15.75 8C15.75 12.2812 12.25 15.75 8 15.75C3.71875 15.75 0.25 12.2812 0.25 8C0.25 3.75 3.71875 0.25 8 0.25ZM11.5625 5.53125C11.5938 5.4375 11.5938 5.34375 11.5625 5.21875C11.5625 5.15625 11.5 5.0625 11.4688 5.03125C11.375 4.9375 11.2188 4.9375 11.1562 4.9375C10.875 4.9375 10.4062 5.09375 8.25 6C7.5 6.3125 6 6.9375 3.75 7.9375C3.375 8.09375 3.1875 8.21875 3.15625 8.375C3.125 8.625 3.53125 8.71875 4 8.875C4.40625 9 4.9375 9.15625 5.21875 9.15625C5.46875 9.15625 5.75 9.0625 6.0625 8.84375C8.15625 7.40625 9.25 6.6875 9.3125 6.6875C9.375 6.6875 9.4375 6.65625 9.46875 6.6875C9.53125 6.75 9.53125 6.8125 9.5 6.84375C9.46875 7 7.5 8.8125 7.375 8.9375C6.9375 9.375 6.4375 9.65625 7.21875 10.1562C7.875 10.5938 8.25 10.875 8.9375 11.3125C9.375 11.5938 9.71875 11.9375 10.1562 11.9062C10.375 11.875 10.5938 11.6875 10.6875 11.0938C10.9688 9.75 11.4688 6.75 11.5625 5.53125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramPlane);
export default __webpack_public_path__ + "static/media/telegram-plane.8115667f2f5b61c3de761214654ceb87.svg";
export { ForwardRef as ReactComponent };